import type { FinancialCacheMetadata } from '../api/admin.api'

type FinancialOverview = {
  dashboard: { cache?: FinancialCacheMetadata }
  series: { cache?: FinancialCacheMetadata }
}

export function adminDashboardComputedAt(
  data: FinancialOverview | undefined,
  receivedAt: number,
): number {
  if (!data) return 0
  return Math.min(
    ...[data.dashboard, data.series].map((response) => {
      const computedAt = response.cache ? Date.parse(response.cache.computedAt) : receivedAt
      return Number.isFinite(computedAt) ? computedAt : receivedAt
    }),
  )
}
